import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/examInspect/evaluate/page',
    add:'/api-ir/bachelor/examInspect/evaluate/add',
    update:'/api-ir/bachelor/examInspect/evaluate/edit',
    info:'/api-ir/bachelor/examInspect/evaluate/',
    del:'/api-ir/bachelor/examInspect/evaluate/',
    export:'/api-ir/bachelor/examInspect/evaluate/export/',
}
// 查询试卷抽查列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增试卷抽查
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改试卷抽查
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询试卷抽查信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除试卷抽查
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 导出试卷抽查信息
export function exportFile (id) {
    return baseAPI.axiosData(api.export+id,'get')
}